<template>
    <div>
        <!--Variant Pathways-->

        <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Variant v-bind:item="item"></NavBar_Variant>
        </span>

            <Loading v-model:active="isLoading" v-model="fullPage"
            :can-cancel="true"
            :is-full-page="fullPage" />

    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Variant from '@/components/navbars/NavBar_Variant';
import active_variants from "@/methods/active_variants";

export default {
    name: 'VariantPathway',
    props: {
    },
    components: {
        Loading,
        NavBar_Variant,
    },
    data: function() {
        return {
            isLoading: false,
            fullPage: true,
        }
    },
    created: async function() {
        this.isLoading=true
        active_variants.loadActiveBiomarkerSNV(this.$route.params.id)
        this.isLoading=false

    }
}
</script>
<style>
</style>